import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Arrow,
  Wrapper,
  Imgcontainer,
  Slide,
  Image,
  InfoContainer,
  Title,
  Desc,
} from "./sliderhome.component";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@material-ui/icons";
import Button from "../button/button.component";
import { sliderItems } from "../../componentdData";
import { useNavigate } from "react-router-dom";
import Heading from "../smallcomponents/heading.component";

const Slider = () => {
  const navigate = useNavigate();
  const [slideIndex, setSlideIndex] = useState(0);
  const sliderRef = useRef(false);

  const handleClick = (direction) => {
    if (direction === "left") {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : 2);
    } else {
      setSlideIndex(slideIndex < 2 ? slideIndex + 1 : 0);
    }
  };

  const handleButtonClick = (url) => {
    const navigateToUrl = () => navigate(url);
    navigateToUrl();
  };

  useEffect(() => {
    if (sliderRef.current) return;
    const id = setInterval(() => {
      handleClick("right");
      sliderRef.current = false;
    }, 4000);

    return () => {
      clearInterval(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideIndex]);

  return (
    <>
      <Heading prop="Season Special" />
      <Container>
        <Arrow direction="left" onClick={() => handleClick("left")}>
          <ArrowLeftOutlined />
        </Arrow>
        <Wrapper slideIndex={slideIndex}>
          {sliderItems.map((item) => (
            <Slide bg={item.bg} key={item.id}>
              <Imgcontainer>
                <Image src={item.img} />
              </Imgcontainer>
              <InfoContainer>
                <Title>{item.title}</Title>
                <Desc>{item.desc}</Desc>
                <span>
                  <Button onClick={() => handleButtonClick(item.url)}>
                    Shop Now
                  </Button>
                </span>
              </InfoContainer>
            </Slide>
          ))}
        </Wrapper>
        <Arrow direction="right" onClick={() => handleClick("right")}>
          <ArrowRightOutlined />
        </Arrow>
      </Container>
    </>
  );
};

export default Slider;
